export  const role_slug_enum = {
    OWNER : "owner",
    MANAGER : "manager",
    SUPERVISOR: "supervisor",
    STAFF: "staff",
    CUSTOMER_SERVICE: "customer-service",
};

// slug : 'route-name'
// description => used for denied permission even though has permission for specific route
export const except_route = {
    // [role_slug_enum.SUPER_ADMIN] : ["officer-dashboard", "inbound-inbox", "outbound-inbox"],
    // [role_slug_enum.POST_OFFICER]: ["parcel.list"]
};


// description => used for access permission only for specific role slug
export const only_route = {
    "role.list"             : [role_slug_enum.SUPER_ADMIN, role_slug_enum.MD],
    "role.edit"             : [role_slug_enum.SUPER_ADMIN, role_slug_enum.MD],
    "permission.list"       : [role_slug_enum.SUPER_ADMIN, role_slug_enum.MD],
    "branch.collection"     : [role_slug_enum.SUPER_ADMIN, role_slug_enum.MD],
    // "parcel.list"           : [role_slug_enum.SUPER_ADMIN, role_slug_enum.CUSTOMER_SERVICE]
    // "mailbag.advance_search": [role_slug_enum.SUPER_ADMIN]
};

export const wide_screen_route = [
    'dashboard',
];

export const dashboard = {
    'owner' : 'dashboard',
    'manager': 'dashboard',
    'supervisor': 'dashboard',
    'staff': { name: 'label', params: { tab: 'search' }},
    'customer-service': { name: 'label', params: { tab: 'search' }}
};

export default {
    role_slug_enum,
    except_route,
    only_route,
    wide_screen_route,
    dashboard,
}
